<div>
  <form id="payment-form">
    <div id="payment-element"></div>
    <button id="submit" [disabled]="loading" (click)="onClickStripePay($event)"
      class="stripe-button text-white font-bold bg-amber-600 hover:bg-amber-700 dark:bg-amber-600 dark:text-white dark:hover:bg-amber-700">
      <div [style.display]="loading ? '' : 'none'" class="spinner" id="spinner"></div>
      <span [style.display]="!loading ? '' : 'none'" id="button-text" [innerText]="getButtonLabel()"></span>
    </button>
    <div [style.display]="stripeErrorMessage ? '' : 'none'" id="payment-message" [innerText]="stripeErrorMessage">
    </div>
  </form>
</div>